import React, { useContext, useEffect } from 'react';
import styles from './Main.module.scss';
import PathContext from '../../context/path';
import MainCover from '../../components/MainCover/MainCover';
import SliderBtn from '../../components/SliderBtn/SliderBtn';
import StoryCard from '../../components/StoryCard';
import Invite from '../../components/Invite';
import Footer from '../../components/Footer';
import MobileContext from '../../context/mobile';
import { Link } from 'react-router-dom';

const Main = () => {
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);

  const cityImage = `${path}/svg/${isMobile ? 'city-mobile' : 'city'}.svg`;

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.cover}>
          <MainCover />
        </div>
        <div className="container">
          <div className={styles.hr} data-anchor={'hr'}>
            <div className={styles.hr__text} data-animate={'fade-in-up'}>
              {isMobile ? (
                <>
                  Ждем тех, кто готов работать
                  <br /> на результат, проявлять инициативу
                  <br /> и прислушиваться к зову своих амбиций. Чтобы вместе
                  следовать миссии
                  <br /> Р-Фарм — обеспечить людей средствами для повышения
                  <br />
                  качества и продолжительности жизни.
                </>
              ) : (
                <>
                  Ждем тех, кто готов работать на результат, проявлять
                  инициативу и прислушиваться к зову своих амбиций. Чтобы вместе
                  следовать миссии Р-Фарм —<br />
                  обеспечить людей средствами для повышения
                  <br /> качества и продолжительности жизни.
                </>
              )}
            </div>
          </div>

          <section className={styles.tasks} data-anchor="tasks">
            <div className={styles.tasks__wrap}>
              <div className={styles.tasks__info} data-animate="fade-in-up">
                <h2 className={styles.tasks__title}>
                  Мы предлагаем нашим
                  <br />
                  сотрудникам решать самые
                  <br />
                  смелые задачи
                </h2>
                <div className={styles.tasks__text}>
                  {isMobile ? (
                    <>
                      От создания молекулы препарата, доклинических и
                      клинических
                      <br />
                      исследований до производства готовых лекарственных форм,
                      их продвижения и<br /> продаж.
                    </>
                  ) : (
                    <>
                      От создания молекулы препарата, доклинических и
                      клинических
                      <br />
                      исследований до производства готовых лекарственных форм,
                      <br />
                      их продвижения и продаж.
                    </>
                  )}
                </div>
              </div>

              <div className={styles.tasks__img} data-animate="fade-in-up">
                <img src={`${path}/svg/molecule.svg`} alt="molecule" />
              </div>
            </div>
          </section>

          <section className={styles.about} data-anchor={'about'}>
            <div className={styles.about__wrap}>
              <div className={styles.about__info} data-animate="fade-in-up">
                <h2 className={styles.about__title}>
                  Главное <br />о Р-Фарм
                </h2>

                <div className={styles.about__text}>
                  {isMobile ? (
                    <>
                      История Р-Фарм началась
                      <br /> в 2001 году с команды из пяти человек
                      <br /> и маленького офиса. Мы постоянно
                      <br /> росли и со временем превратились
                      <br /> в международный бизнес с тысячами сотрудников и
                      десятком производственных площадок.
                    </>
                  ) : (
                    <>
                      История Р-Фарм началась в 2001 году
                      <br /> с команды из пяти человек и маленького офиса.
                      <br /> Мы постоянно росли и со временем
                      <br /> превратились в международный бизнес
                      <br /> с тысячами сотрудников и десятком производственных
                      площадок.
                    </>
                  )}
                </div>

                {!isMobile && (
                  <Link
                    to={{ pathname: 'about', search: window.location.search }}
                    className={styles.about__btn}
                  >
                    <SliderBtn color="green" text="Изучить" />
                  </Link>
                )}
              </div>

              <div className={styles.about__img} data-animate="fade-in-up">
                <img src={cityImage} alt="city" />
              </div>

              {isMobile && (
                <Link
                  to={{ pathname: 'about', search: window.location.search }}
                  className={styles.about__btn}
                >
                  <SliderBtn color="green" text="Изучить" />
                </Link>
              )}
            </div>
          </section>

          <section className={styles.stories} data-anchor={'stories'}>
            <h2 className={styles.stories__title} data-animate={'fade-in-up'}>
              Истории сотрудников
            </h2>
            <div className={styles.stories__list}>
              <div className={styles.stories__card}>
                <StoryCard
                  img={'story-card-1'}
                  type={'Карьера'}
                  quote={
                    'Мне всегда нужны вызовы и новые проекты. Не могу находиться в трясине'
                  }
                  desc={'История планомерного\nкарьерного роста'}
                  name={'Светлана Иващенко'}
                  position={
                    'заместитель директора департамента региональных продаж\nпо Москве и Московской области'
                  }
                  color={'green_light'}
                  href={'story-svetlana'}
                  mobileDesc={
                    'История планомерного карьерного роста Светланы Иващенко'
                  }
                />
              </div>

              <div className={styles.stories__card}>
                <StoryCard
                  img={'story-card-3'}
                  type={'Свобода'}
                  quote={'Не раз чувствовала, насколько много здесь свободы'}
                  desc={'История о свободе жить,\nдействовать, мечтать'}
                  name={'Евгения Завершинская'}
                  position={'менеджер\nпо маркетингу'}
                  color={'red'}
                  href={'story-evgenia'}
                  mobileDesc={
                    'История Евгении Завершинской о свободе\nжить, действовать, мечтать'
                  }
                />
              </div>

              <div className={styles.stories__card}>
                <StoryCard
                  img={'story-card-5'}
                  type={'Международное сотрудничество'}
                  quote={
                    'Не жалею о взлетах и падениях – есть что рассказать внукам'
                  }
                  desc={'О работе в Китае, России и Германии'}
                  name={'Дмитрий Николаев'}
                  position={
                    'менеджер технического трансфера на заводе Р-Фарм в Германии'
                  }
                  color={'purple'}
                  href={'story-dmitry'}
                  mobileDesc={
                    'Дмитрий Николаев о работе в Китае, России и Германии'
                  }
                />
              </div>

              <div className={styles.stories__card}>
                <StoryCard
                  img="story-card-6"
                  type="У истоков"
                  quote={
                    'Начинала с нуля — \nтеперь помогаю другим находить свой путь'
                  }
                  desc="История о том, как энтузиазм и команда превращают идеи в систему"
                  name="Екатерина Репкина"
                  position="директор департамента подготовки кадров"
                  color="green-secondary"
                  href="story-ekaterina"
                  mobileDesc={
                    'Екатерина Репкина \nИстория о том, как энтузиазм \nи команда превращают идеи \nв систему'
                  }
                />
              </div>
            </div>
          </section>
        </div>
        <div className={styles.final}>
          <div className="container">
            <div className={styles.invite} data-anchor={'invite'}>
              <Invite
                color={'green'}
                form={'full'}
                use={'main'}
                title={'Присоединяйтесь к команде Р-Фарм'}
                desc={
                  'Если хотите работать на результат, проявлять себя и заниматься полезным для общества делом в международном фармацевтическом бизнесе'
                }
              />
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <Footer color={'main'} />
        </div>
      </div>
    </>
  );
};

export default Main;
